import { Input, InputNumber } from "antd";
import Delete from "../../assets/Delete";

const columns = (handleAction) => [
  {
    title: "Title",
    dataIndex: "title",
    render: (_, record) => (
      <Input
        value={record?.title}
        onChange={(e) =>
          handleAction("edit", record, { title: e?.target?.value })
        }
      />
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    render: (_, record) => (
      <Input
        value={record?.description}
        onChange={(e) =>
          handleAction("edit", record, { description: e?.target?.value })
        }
      />
    ),
  },
  {
    title: "Unit",
    dataIndex: "unit",
    render: (_, record) => (
      <InputNumber
        min={1}
        controls={false}
        value={record?.unit}
        onChange={(value) =>
          handleAction("edit", record, {
            unit: value,
            charge: (value || 0) * (record?.amount || 0),
          })
        }
      />
    ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (_, record) => (
      <InputNumber
        // min={0}
        controls={false}
        prefix={record?.type === "deduction" ? "-" : ""}
        suffix="$"
        value={Math.abs(record?.amount || 0)}
        onChange={(value) => {
          const amount = record?.type === "deduction" ? -value : value;
          handleAction("edit", record, {
            amount,
            charge: (record?.unit || 0) * (amount || 0),
          });
        }}
      />
    ),
  },
  {
    title: "Tax",
    dataIndex: "tax",
    render: (_, record) => (
      <InputNumber
        min={0}
        max={100}
        controls={false}
        suffix="%"
        value={record?.tax}
        onChange={(value) => handleAction("edit", record, { tax: value || 0 })}
        disabled={record?.type === "deduction"}
      />
    ),
  },
  {
    title: "Charge",
    dataIndex: "charge",
    render: (_, record) => `$ ${(record?.unit || 0) * (record?.amount || 0)}`,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: (_, record) => (
      <button type="button" onClick={() => handleAction("delete", record)}>
        <Delete />
      </button>
    ),
  },
];

export default columns;
